
import { computed, defineComponent } from 'vue';

import { FILES } from '../files';

import InformationFileItem from './InformationFileItem.vue';

export default defineComponent({
  name: 'InformationDocumentBlock',
  components: {
    InformationFileItem,
  },
  setup() {
    const getLastItemIndex = computed(() => FILES.length - 1);

    return {
      FILES,
      getLastItemIndex,
    };
  },
});
